import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { List, ListItem } from '@mui/material';

import ChevronRightIcon from 'components/Common/Icons/ChevronRight';
import CloseIcon from 'components/Common/Icons/Close';
import SortIcon from 'components/Common/Icons/Sort';
import Button from 'components/UI/Buttons/Button/Button';
import Drawer, { DrawerHeader } from 'components/UI/Drawer/Drawer';
import Link from 'components/UI/Link/Link';
import { SortingChildrenType } from 'components/Listing/Sorting/Sorting';
import { getUri } from 'services/generic';

import styles from './SortingMobile.module.scss';

export default function SortingMobile({
  sorting,
  onSort,
}: SortingChildrenType): JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  function openDrawer() {
    if (!open) setOpen(true);
  }

  function closeDrawer() {
    if (open) setOpen(false);
  }

  function handleSort(label: string) {
    closeDrawer();
    onSort(label);
  }

  return (
    <>
      <Button onClick={openDrawer} className={styles.button}>
        {t('LABEL_SORT')}
        <SortIcon className={styles.buttonIcon} />
      </Button>
      <Drawer
        open={open}
        onClose={closeDrawer}
        classes={{ paper: styles.drawerPaper }}
      >
        <DrawerHeader className={styles.drawerHeader}>
          <div className={styles.title}>{t('LABEL_SORT')}</div>
          <Button onClick={closeDrawer} className={styles.close}>
            <CloseIcon />
          </Button>
        </DrawerHeader>
        <List className={styles.drawerInnerContainer}>
          {sorting.map(({ label, url, isApplied }) => (
            <ListItem key={label} className={styles.item} disablePadding>
              <Link
                key={label}
                to={getUri(url)}
                onClick={() => handleSort(label)}
                className={classNames(styles.link, {
                  [styles.applied]: isApplied,
                })}
              >
                {label}
                <ChevronRightIcon className={styles.linkIcon} />
              </Link>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
